export default "__VITE_ASSET__688be27d__"